export default __webpack_public_path__ + "static/media/img_profile_default.ca39420b.svg";